var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6  col-lg-3"},[_c('b-form-group',{attrs:{"label":_vm.Label,"description":""}},[_c('b-form-input',{attrs:{"disabled":""},model:{value:(_vm.Wert),callback:function ($$v) {_vm.Wert=$$v},expression:"Wert"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }